// extracted by mini-css-extract-plugin
module.exports = {"search":"search-module--search--1Wk5g","cancelButton":"search-module--cancelButton--3Ed0p","searchIcon":"search-module--searchIcon--2cYtz"};